export default __webpack_public_path__ + "static/media/RoundGradConnecting.8f907c71.svg";